import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Ana', 'Pedro', 'Lucía', 'Miguel', 'Carmen', 'José', 'Rosa'];
const CITIES = ['Buenos Aires, Argentina', 'Ciudad de México, México', 'Bogotá, Colombia', 'Lima, Perú', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Caracas, Venezuela', 'San José, Costa Rica', 'Guatemala City, Guatemala'];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const scheduleNext = () => {
      const delay = Math.random() * (12000 - 8000) + 8000; // 8-12 seconds
      setTimeout(() => {
        const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
        const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
        setData({
          name: randomName,
          city: randomCity
        });
        setVisible(true);
        // Hide after 4 seconds
        setTimeout(() => {
          setVisible(false);
          scheduleNext(); // Schedule the next one after hiding
        }, 4000);
      }, delay);
    };
    scheduleNext();
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-green-500 flex items-center gap-3 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-327">
      <div className="bg-green-100 p-2 rounded-full" data-id="element-328">
        <CheckCircle className="w-6 h-6 text-green-600" data-id="element-329" />
      </div>
      <div data-id="element-330">
        <p className="text-sm font-bold text-gray-800" data-id="element-331">
          {data.name} acaba de comprar
        </p>
        <p className="text-xs text-gray-500" data-id="element-332">{data.city}</p>
        <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-333">
          Economía Lista™
        </p>
      </div>
    </div>;
}